import api from './api';

const addressService = {
  getAll: async (params = {}) => {
    const response = await api.get('/addresses', { params });
    const data = response.data;
    // Rückwärtskompatibilität: Wenn die Response ein Objekt mit "addresses" ist, extrahiere das Array
    return data.addresses || data;
  },

  getAllPaginated: async (params = {}) => {
    const response = await api.get('/addresses', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/addresses/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/addresses', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/addresses/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/addresses/${id}`);
    return response.data;
  },

  // Papierkorb: gelöschte Adressen (nur Admins) und Wiederherstellen
  papierkorb: async (suche = '') => {
    const response = await api.get('/addresses/papierkorb', { params: suche ? { suche } : {} });
    return response.data;
  },

  restore: async (id) => {
    const response = await api.post(`/addresses/${id}/restore`);
    return response.data;
  },

  hide: async (id) => {
    const response = await api.post(`/addresses/${id}/hide`);
    return response.data;
  },

  unhide: async (id) => {
    const response = await api.post(`/addresses/${id}/unhide`);
    return response.data;
  },

  search: async (query) => {
    const response = await api.post('/addresses/search', { query });
    return response.data;
  },

  // Lieferanten-Autocomplete für die Buchungsmaske (Lieferanten zuerst)
  supplierSearch: async (q, limit = 8) => {
    const response = await api.get('/addresses/supplier-search', { params: { q, limit } });
    return response.data;
  },

  // Belege/Buchungen, die mit dieser Adresse als Lieferant verknüpft sind
  getBuchungen: async (id, params = {}) => {
    const response = await api.get(`/addresses/${id}/buchungen`, { params });
    return response.data;
  },

  exportBuchungen: async (id, format, params = {}) => {
    const response = await api.get(`/addresses/${id}/buchungen/export/${format}`, { params, responseType: 'blob' });
    return response;
  },

  getProjects: async (id) => {
    const response = await api.get(`/addresses/${id}/projects`);
    return response.data;
  },

  getTasks: async (id) => {
    const response = await api.get(`/addresses/${id}/tasks`);
    return response.data;
  },

  getBacklinks: async (id) => {
    const response = await api.get(`/addresses/${id}/backlinks`);
    return response.data;
  },

  // Favoriten
  toggleFavorite: async (id) => {
    const response = await api.post(`/addresses/${id}/favorite`);
    return response.data;
  },

  getFavorites: async () => {
    const response = await api.get('/addresses/favorites/list');
    return response.data;
  },

  // Kontakt-Historie
  logContactHistory: async (entry) => {
    const response = await api.post('/contact-history', entry);
    return response.data;
  },

  getContactHistory: async (addressId, limit = 50) => {
    const response = await api.get('/contact-history', {
      params: { address_id: addressId, limit }
    });
    return response.data;
  },

  // Meta-Daten (Tags, Suchbegriffe)
  getAllTags: async () => {
    const response = await api.get('/addresses/meta/tags');
    return response.data;
  },

  getAllSearchTerms: async () => {
    const response = await api.get('/addresses/meta/search-terms');
    return response.data;
  },

  // Unternehmensbereiche (Business Divisions)
  getBusinessDivisions: async () => {
    const response = await api.get('/addresses/meta/business-divisions');
    return response.data;
  },

  // Adress-Bild
  uploadImage: async (addressId, formData) => {
    const response = await api.post(`/addresses/${addressId}/image`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteImage: async (addressId) => {
    const response = await api.delete(`/addresses/${addressId}/image`);
    return response.data;
  },
};

export default addressService;
